import { StreamActions } from "@hotwired/turbo";

// L'import d'un calque vient d'aboutir (Documents::StickerImportsController#create). Aucun DOM à
// remplacer : les éditeurs possèdent leur document en mémoire — on diffuse le document greffé
// comme un événement, l'éditeur monté l'adopte (les îlots du publisher se gardent eux-mêmes).
StreamActions.composition_document_imported = function () {
  let detail;
  try {
    detail = JSON.parse(this.getAttribute("detail"));
  } catch (e) {
    console.error("composition_document_imported : JSON invalide", e);
    return;
  }

  window.dispatchEvent(new CustomEvent("composition-document:imported", { detail }));
};
